import React, { useEffect, useState } from "react";
import { _Filter_Items } from "..";
import { Row, Col, Collapse } from "antd";
import { _Filter_Types } from "..";
import { TenantCheckbox } from ".";
import Services from "../../../../Services/dataService";
const SelectedPanelColor = "#bae7ff";
const { Panel } = Collapse;
const convertToK = value => {
	if (value >= 1000000) {
		return `${(value / 1000000).toFixed(1)}M`;
	} else if (value >= 1000) {
		return `${(value / 1000).toFixed(1)}K`;
	}
	return value;
};
function CustomMinMax({ _Label, _ApiTag, value, _SectionApiTag, dispatch, defaultActiveKey, _extra, tenant }) {
	let [{ min, max }, setMinMax] = useState({ min: "Loading", max: "Loading" });
	useEffect(() => {
		async function fetchData() {
			let { data } = await Services.getMinMax({ _ApiTag });
			setMinMax(data);
		}
		fetchData();
	}, [_ApiTag]);
	return (
		<>
			<Collapse
				defaultActiveKey={defaultActiveKey}
				onChange={() => {}}
				style={{ "background-color": value ? SelectedPanelColor : "#f0f0f0f0" }}
			>
				<Panel
					header={_Label}
					key={_ApiTag}
					extra={[
						<>
							{_extra && (
								<TenantCheckbox tenant={tenant} _ApiTag={_ApiTag} _extra={_extra} dispatch={dispatch} />
							)}
							{`Min : ${convertToK(min)} Max: ${convertToK(max)}`}
						</>
					]}
				>
					<Row gutter={[48, 8]}>
						<Col span={12}>
							{/* <h5>Min</h5> */}
							{_Filter_Items[_Filter_Types.Input]({
								_SectionApiTag,
								_Label: "Min",
								_placeholder: `${_Label} Min`,
								_Child_ApiTag: "$gte",
								_ApiTag,
								value: value ? value["$gte"] : "",
								dispatch
							})}
						</Col>
						<Col span={12}>
							{_Filter_Items[_Filter_Types.Input]({
								_SectionApiTag,
								_Label: "Max",
								_placeholder: `${_Label} Max`,
								_Child_ApiTag: "$lte",
								_ApiTag,
								value: value ? value["$lte"] : "",
								dispatch
							})}
						</Col>
					</Row>
				</Panel>
			</Collapse>
		</>
	);
}

export default React.memo(CustomMinMax);
